<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20">
  <mat-card *ngIf="user.role === 'ROLE_ADMIN'" style="margin-top: 20px;">
    <mat-card-content>
      <button mat-raised-button routerLink="/industriepartner">Alle Industriepartner</button>
    </mat-card-content>
  </mat-card>
  <mat-card style="margin-top: 20px;">
    <mat-card-header>
      <mat-card-title>
        Industriepartner {{industriepartner?.nama}}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </mat-card-content>
    <mat-card-content *ngIf="!loading" fxLayoutAlign="start start">
      <mat-card fxFlex="50">
        <mat-list>
          <mat-list-item *ngIf="industriepartnerAuth">
            <span>Kundenkennung (Login)</span>
            <span style="margin-left: auto;">{{industriepartnerAuth?.kundenkennung}}</span>
          </mat-list-item>
          <mat-list-item>
            <span>Kundenummer</span>
            <span style="margin-left: auto;">{{industriepartner?.kundennumm}}</span>
          </mat-list-item>
          <mat-list-item>
            <span>Name</span>
            <span style="margin-left: auto;">{{industriepartner?.nama}}</span>
          </mat-list-item>
          <mat-list-item>
            <span>Straße</span>
            <span style="margin-left: auto;">{{industriepartner?.strasse}}</span>
          </mat-list-item>
          <mat-list-item>
            <span>PLZ</span>
            <span style="margin-left: auto;">{{industriepartner?.plz}}</span>
          </mat-list-item>
          <mat-list-item>
            <span>Ort</span>
            <span style="margin-left: auto;">{{industriepartner?.ort}}</span>
          </mat-list-item>
        </mat-list>
      </mat-card>
      <mat-card fxFlex="33" style="margin-left: auto;" *ngIf="user.role == 'ROLE_ADMIN' && industriepartnerAuth">
        <mat-card-header>
          <mat-card-title *ngIf="!industriepartnerAuth.gesperrt">
            Software-Zugang deaktivieren
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <button mat-raised-button color="warn" style="width: 100%;" *ngIf="!industriepartnerAuth.gesperrt" (click)="deactivate()">
            Deaktivieren
          </button>
          <button mat-raised-button color="primary" style="width: 100%;" *ngIf="industriepartnerAuth.gesperrt" (click)="activate()">
            Aktivieren
          </button>
          <div class="alert alert-success alert-dismissible mt-2" *ngIf="newPassword">
            Zugang angelegt. Passwort: <strong>{{newPassword}}</strong>
          </div>
          <div *ngIf="industriepartnerAuth" class="mt-2">
            <b>Haupt-Zugang Kontaktdaten</b>
            <mat-list>
              <mat-list-item>
                <span>E-Mail</span>
                <span style="margin-left: auto;">{{industriepartnerAuth.email}}</span>
              </mat-list-item>
              <mat-list-item>
                <span>Telefon</span>
                <span style="margin-left: auto;">{{industriepartnerAuth.phone}}</span>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-card-content> 
      </mat-card>
      <mat-card fxFlex="33" style="margin-left: auto;" *ngIf="user.role == 'ROLE_ADMIN' && !industriepartnerAuth">
        <mat-card-content>
          <div class="alert-info">
            Dieser Industriepartner hat noch keinen Software-Zugang.
          </div>
          <div>
            <mat-form-field style="width: 100%;">
              <input matInput placeholder="Vorname" [(ngModel)]="authIndForm.vorname" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
              <input matInput placeholder="Nachname" [(ngModel)]="authIndForm.nachname" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
              <input matInput type="email" placeholder="E-Mail" [(ngModel)]="authIndForm.email" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
              <input matInput placeholder="Telefon" [(ngModel)]="authIndForm.phone" required>
            </mat-form-field>
          </div>
          <button mat-raised-button color="primary" class="mt-2" style="width: 100%;" [disabled]="creatingAuth || !validAddAuthForm()" (click)="addIndustrieAuth()">
            Software-Zugang anlegen
          </button>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
  <mat-card style="margin-top: 20px; margin-bottom: 20px;" *ngIf="industriepartnerAuth && !industriepartnerAuth?.gesperrt">
    <mat-card-header>
      <mat-card-title>
        Industriepartner-Mitarbeiter
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="loadingSubs">
      <mat-spinner diameter="30"></mat-spinner>
    </mat-card-content>
    <mat-card-content *ngIf="!loadingSubs">
      <div class="alert-info" *ngIf="subIndustriepartner.data.length == 0">
        Sie haben noch keine Industriepartner-Mitarbeiter angelegt.
      </div>
      <div class="alert-info" *ngIf="subIndustriepartner.data.length > 0 && filteredSubIndustriepartner.data.length == 0">
        Es gibt keine Industriepartner-Mitarbeiter, die zu Ihren Filtereinstellungen passen.
      </div>
      <table mat-table [hidden]="filteredSubIndustriepartner.data.length == 0" [dataSource]="filteredSubIndustriepartner" matSort style="width: 100%;" >
        <ng-container matColumnDef="kundenkennung">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Kundenkennung (Login)
          </th>
          <td mat-cell *matCellDef="let element">
            <span >
              <i *ngIf="!element.kundenkennung">wird generiert...</i>
              <strong *ngIf="element.kundenkennung">{{element.kundenkennung}}</strong>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="vorname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Vorname
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>Vorname</mat-label>
              <input matInput [(ngModel)]="element.vorname">
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.vorname}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nachname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Nachname
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>Nachname</mat-label>
              <input matInput [(ngModel)]="element.nachname">
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.nachname}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            E-Mail
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>E-Mail</mat-label>
              <input matInput [(ngModel)]="element.email" type="email" required>
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.email}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef style="text-align: right !important;">
            Aktionen
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;">
            <button mat-raised-button [disabled]="element.saving" color="primary" *ngIf="element.edit" (click)="saveSubIndustriepartner(element)">
              Speichern
            </button>
            <button mat-raised-button [disabled]="element.saving" color="warn" *ngIf="!element.edit" (click)="deleteSubIndustriepartner(element)">
              Löschen
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['kundenkennung', 'vorname', 'nachname', 'email','action']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['kundenkennung', 'vorname', 'nachname', 'email','action'];"></tr>
      </table>
    </mat-card-content>
    <mat-card-footer>
      <button mat-raised-button color="primary" style="width: 100%;" (click)="addSubIndustriepartner()">
        Industriepartner-Mitarbeiter hinzufügen
      </button>
    </mat-card-footer>
  </mat-card>
</div>
